module.exports = __webpack_public_path__ + "images/dingtalk/500-9e6f8a1b881f5bf265f2db5f86416384.png";